// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "app.stickey",
    name: "Stickey Wallet",
    homepage: "https://stickey.app",
    image_id: "12aab9fb-f3d4-4248-10e0-4eda17a5de00",
    app: {
        browser: "https://stickey.app",
        ios: "https://apps.apple.com/app/id1671113083",
        android: "https://play.google.com/store/apps/details?id=app.stickey",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "stickyapp://",
        universal: "https://stickeyapp.page.link",
    },
    desktop: {
        native: "stickyapp://",
        universal: "https://stickeyapp.page.link",
    },
};
//# sourceMappingURL=index.js.map